import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import Code from 'components/Code'

const Embed = ({ onCopy, match }) => (
  <article className="page article">
    <section className="content">
      <Grid fluid>
        <Row>
          <Col xs={12}>
            <h1>Here is your embed code</h1>
            <p>
              Copy and paste this code to your web page in the place where you want the booking system to appear.&nbsp;
              <a
                rel="noopener noreferrer"
                href="https://birdietime.zendesk.com/hc/en-us/sections/115000489625-First-steps"
                target="_blank"
              >
                Usage instructions
              </a>.
            </p>
            <Code onCopy={onCopy} {...match.params} />
          </Col>
        </Row>
      </Grid>
    </section>
  </article>
)


export default Embed



// WEBPACK FOOTER //
// ./src/pages/Embed.js